<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <AppToast ref="toastRef" />
    <AppConfirm ref="confirmRef" />
  </div>
</template>

<script setup>
import { ref, provide } from "vue";
import { useStore } from "vuex";
import AppToast from "@/components/common/AppToast.vue";
import AppConfirm from "@/components/common/AppConfirm.vue";

const store = useStore();
store.dispatch("company/fetchCompany");

const toastRef = ref(null);
const confirmRef = ref(null);
provide("$toast", {
  show: (text, type, duration) => toastRef.value?.show(text, type, duration),
  dismiss: (id) => toastRef.value?.dismiss(id),
});
provide("$confirm", {
  confirm: (msg, opts) =>
    confirmRef.value?.confirm(msg, opts) ?? Promise.resolve(false),
  alert: (msg) => confirmRef.value?.alert(msg) ?? Promise.resolve(),
  prompt: (msg, def) =>
    confirmRef.value?.prompt(msg, def) ?? Promise.resolve(null),
});
</script>

<style>
@import "../src/assets/css/base.css";

.fade-enter-active,
.fade-leave-active {
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;
}
.fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
